import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

import styles from './style.scss';

const RestrictionsTooltip = ({isInputPristine, restrictions, failingRestrictions}) => {
    const failingRestrictionsSet = new Set(failingRestrictions);

    return (
        <div className="restrictions-tooltip">
            {
                restrictions.map((restriction, index) => (
                    <div key={index} className="restriction">
                        <div>
                            {
                                isInputPristine &&
                                !failingRestrictionsSet.has(restriction) ?
                                    <CheckIcon className="check-icon" /> :
                                    <CloseIcon className="error-icon" />
                            }
                        </div>

                        <div>
                            {restriction}
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

RestrictionsTooltip.protoType = {
    isInputPristine: PropTypes.bool,
    restrictions: PropTypes.arrayOf(PropTypes.string),
    failingRestrictions: PropTypes.arrayOf(PropTypes.string)
};

export default RestrictionsTooltip;


// WEBPACK FOOTER //
// ./src/components/portal/controls/restrictionsTooltip/restrictionsTooltip.jsx